"use client"

import dynamic from "next/dynamic"
import { ComponentType } from "react"
import type { CompteurLoiLemoineProps } from "@/app/components/atomic/organisms/CompteurLoiLemoine"

// Code-split so guide pages without the counter never ship it, but server-rendered so its figure stays citable
const CompteurLoiLemoine = dynamic(
    () =>
        import("@/app/components/atomic/organisms/CompteurLoiLemoine") as Promise<{
            default: ComponentType<CompteurLoiLemoineProps>
        }>,
)

const CompteurLoiLemoineCompact = dynamic(
    () =>
        import("@/app/components/atomic/organisms/CompteurLoiLemoineCompact") as Promise<{
            default: ComponentType<CompteurLoiLemoineProps>
        }>,
)

const CompteurLoiLemoineLazy = ({ compact = false, ...props }: CompteurLoiLemoineProps & { compact?: boolean }) =>
    compact ? <CompteurLoiLemoineCompact {...props} /> : <CompteurLoiLemoine {...props} />

export default CompteurLoiLemoineLazy
